import React, { useState } from 'react';
import reportLogo from './assets/ReportLogo.png';
import ActionsBar from './actionsBar';
import QRCode from 'react-qr-code';

interface Study {
  user?: {
    username?: string;
  };
  patient?: {
    patient_id?: string;
    patient_name?: string;
    patient_last_name?: string;
  };
}

interface ReportData {
  report?: {
    is_completed?: boolean;
  };
}

interface ReportHeaderProps {
  study: Study;
  saveReport: () => void;
  resetReportObjValues: () => void;
  setExamData: (data: unknown) => void;
  examData: unknown;
  setResetActive: (active: boolean) => void;
  resetActive: boolean;
  downloadPDF: () => void;
  editMode: boolean;
  handleSwitchChange: () => void;
  handlEditReport: () => void;
  finishMode: boolean;
  ohifViewer: boolean;
  finished: boolean;
  loadingFinished: boolean;
  setReportDetails: (details: unknown) => void;
  data: ReportData;
  UploadPending: boolean;
  aiAccelerate: boolean;
  reset: () => void;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  study,
  saveReport,
  resetReportObjValues,
  setExamData,
  examData,
  setResetActive,
  resetActive,
  downloadPDF,
  editMode,
  handleSwitchChange,
  handlEditReport,
  finishMode,
  ohifViewer,
  finished,
  loadingFinished,
  setReportDetails,
  data,
  UploadPending,
  aiAccelerate,
  reset,
}) => {
  const [qrSrc] = useState('');

  const getCurrentDate = () => {
    const now = new Date();
    const yy = String(now.getFullYear()).slice(2); // Get last 2 digits
    const mm = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yy}/${mm}/${dd}`;
  };

  return (
    <div className="col-span-12 w-full flex-shrink-0">
      <ActionsBar
        saveReport={saveReport}
        resetReportObjValues={resetReportObjValues}
        setExamData={setExamData}
        examData={examData}
        setResetActive={setResetActive}
        resetActive={resetActive}
        downloadPDF={downloadPDF}
        editMode={editMode}
        finishMode={data?.report?.is_completed}
        finished={finished}
        data={data}
        setReportDetails={setReportDetails}
        ohifViewer={ohifViewer}
        loadingFinished={loadingFinished}
        handlEditReport={handlEditReport}
        handleSwitchChange={handleSwitchChange}
        UploadPending={UploadPending}
        aiAccelerate={aiAccelerate}
        reset={reset}
      />
      <div
        className="flex w-full items-center justify-between border-t border-b border-[#A6ABC8] bg-card-color-100 py-3 px-5"
        id="headerContent"
        style={{
          fontFamily: "'Poppins', sans-serif",
        }}
      >
        <div className="flex-col space-y-3 font-semibold">
          <div className="flex-col">
            <div className="text-3xl font-bold text-title-page-color-100">
              FETAL BIOMETRY
            </div>
            <div className="-mt-2 text-lg font-semibold text-[#2886C7]">
              Ultrasound Report
            </div>
          </div>
          <div className="flex flex-col space-y-0.5 text-base font-normal text-title-page-color-100">
            <div>
              <span className="font-semibold">PRACTICIONAER NAME : </span> Dr.{' '}
              {study?.user?.username ? study?.user?.username : '*****'}
            </div>
            <div>
              <span className="font-semibold">EXAM DATE : </span>{' '}
              {getCurrentDate()}
            </div>
          </div>
        </div>
        <div className="flex h-16 items-center justify-center">
          <img src={reportLogo} className="w-80" />
        </div>
        <div className="w-fit">
          <div className="flex w-full">
            <div className="flex w-60 flex-col justify-center space-y-3 text-base font-normal text-title-page-color-100">
              <div className="flex justify-between">
                <span className="font-semibold">PATIENT ID : </span>{' '}
                <span>{study?.patient?.patient_id}</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">PATIENT CITY : </span>{' '}
                <span> MOROCCO / RABAT</span>
              </div>
              <div className="flex justify-between">
                <span className="font-semibold">PATIENT NAME : </span>{' '}
                <span>
                  {' '}
                  {study?.patient?.patient_name}{' '}
                  {study?.patient?.patient_last_name}
                </span>
              </div>
            </div>
            <div className="ml-4 flex w-[101.93px] flex-col items-center justify-center text-title-page-color-100">
              <div className="text-[8px] font-bold">ACCESS FULL EXAM</div>
              <QRCode
                className=""
                value={qrSrc}
                bgColor={'white'}
                fgColor={'black'}
                size={68}
              />
              <h4 className=" text-center text-sm">27534897</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
